import { render, staticRenderFns } from "./TeamDataTable.vue?vue&type=template&id=2724db87&scoped=true&"
import script from "./TeamDataTable.vue?vue&type=script&lang=js&"
export * from "./TeamDataTable.vue?vue&type=script&lang=js&"
import style0 from "./TeamDataTable.vue?vue&type=style&index=0&id=2724db87&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2724db87",
  null
  
)

export default component.exports